import React from 'react'
import { AdminHome } from './AdminHome'
import { AdminNav } from '../layouts/AdminNav'
import { AdminServices } from './AdminServices'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
// import { useAuthRefreshQuery } from '../lib/api/authAPI'
import { useNavigate } from 'react-router-dom'
// import { setAccessToken } from '../lib/slices/authSlice'

export const Admin = () => {
    // const { data, isLoading, error } = useAuthRefreshQuery()
    const navigate = useNavigate()
    // const dispatch = useDispatch()
    const adminInfo = useSelector((state) => state.auth.adminInfo)
    const { pathname } = useLocation();
    if (adminInfo === null || !adminInfo) {
        navigate('/login')
    }

    // if (isLoading) return <div>Loading...</div>
    // if (error) {
    //     navigate('/login')
    // }
    // if (data) {
    //     const { accessToken } = data
    //     dispatch(setAccessToken(accessToken))
    // }
    return (
        <main className='min-h-[100vh] flex flex-col'>
            <AdminNav />
            {
                pathname.includes("/clinics") ? <AdminServices /> : <AdminHome adminInfo={adminInfo} />
            }
        </main>
    )
}